/**
 * Returns a new object with the specified keys omitted.
 *
 * @param obj - The source object.
 * @param keys - An array of keys to omit from the result.
 * @returns A new object with the specified keys removed.
 *
 * @example
 * const result = omit({ a: 1, b: 2, c: 3 }, ['b']);
 * // result: { a: 1, c: 3 }
 */
export const omit = <T extends Record<string, unknown>, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> => {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key as K))) as Omit<T, K>
}
